/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_UppercaseInputs */



/**
* | output |
* | --- |
* | "Auto Uppercase" |
*
* @param {Auto_UppercaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_uppercase = /** @type {((inputs?: Auto_UppercaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_UppercaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Majuscules automatiques")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Großschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Maiuscolo automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматический ввод верхнего регистра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mayúsculas automáticas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动大写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動大文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो अपरकेस")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Maiúsculas automáticas")
	return /** @type {LocalizedString} */ ("Auto Uppercase")
});